import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterAboutUsComponent } from './footer-about-us.component';
import { TranslateModule } from '@ngx-translate/core';
import { FooterAboutUsRoutingModule } from './footer-about-us-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FooterAboutUsRoutingModule,
    TranslateModule
  ],
  declarations: [
    FooterAboutUsComponent
  ]
})
export class FooterAboutUsModule { } 